// 系统品牌 Logo —— Blade「b」标,系统自带、固定内置资源。
//
// 这是 Blade OS 的系统 logo(任务栏开始按钮 / 登录页 / favicon 统一使用)。
// 它在构建期被打包进产物,是全系统唯一的品牌标识来源。
//
// ⚠️ 禁止外部修改:此 logo 不允许被外部/运行时覆盖。
//   - 不得改为从 apps.yaml、后端 /api/v1/apps/icon/<name>、用户设置、
//     远程 URL 等任何「可外部配置」的来源加载。
//   - 需要用到系统 logo 的地方一律 import 此常量,不要各自重新引资源,
//     以保证全站唯一且不可被外部替换。
import logoUrl from '../assets/logo_without_name.webp';

export const SYSTEM_LOGO_URL: string = logoUrl;
